/**
 * Simple vanilla lightbox for image galleries.
 * Attach to links with data-lightbox="image" attribute.
 */
export function initLightbox() {
  let overlay = null;

  function open(src, alt) {
    if (overlay) close();

    overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.innerHTML = `
      <button class="lightbox-close" aria-label="Close lightbox">&times;</button>
      <img class="lightbox-img" src="${src}" alt="${alt || ''}">
    `;

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay || e.target.classList.contains('lightbox-close')) {
        close();
      }
    });

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => overlay.classList.add('is-active'));

    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    overlay.addEventListener('transitionend', () => {
      overlay.remove();
      overlay = null;
    }, { once: true });
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-lightbox="image"]');
    if (!link) return;
    e.preventDefault();
    const img = link.querySelector('img');
    open(link.href, img ? img.alt : '');
  });
}
